import { PageHeaderStatic, WidgetIcon } from '@procureai/ui-mui';

import { BaseDomainType } from '~/common/types';
import { BasePageTitle } from '~/components/BasePageTitle/BasePageTitle';
import { DataGridQueryBuilder, useDataGridQueryBuilderQuery } from '~/components/DataGridQueryBuilder';
import { DataGridWidget } from '~/components/DataGridWidget';
import { DomainIcon } from '~/components/DomainIcon/DomainIcon';
import { Filters, FilterSaveStatus, useFilters } from '~/components/Filters';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { RouteId } from '~/routes';

import { useOrderDataGridConfig } from './PurchaseOrderList.dataGrid';
import { BASE_ORDER_LIST_QUERY } from './PurchaseOrderList.gql';
import { useOrderDataGridQueryBuilderConfig } from './PurchaseOrderList.queryBuilder';

const domain = BaseDomainType.ORDER;

export const PurchaseOrderList = () => {
  const { queryId, query, onQueryChange, onQueryIdChange, rulesTotal, loading } = useDataGridQueryBuilderQuery({
    domain,
  });
  const { onFilterSave, saveStatus, selected, ...filtersProps } = useFilters({ domain, queryId });

  return (
    <PageLayout
      fullHeight
      renderHeader={
        <>
          <PageHeaderStatic
            title={<BasePageTitle domain={domain} />}
            maxWidth={false}
            icon={<WidgetIcon icon={<DomainIcon domain={domain} />} />}
            right={
              <Filters
                {...filtersProps}
                selected={selected}
                onFilterSelect={(filter) => {
                  onQueryIdChange(filter.queryId);
                }}
              />
            }
          />
          <DataGridQueryBuilder
            query={query}
            clearDisabled={rulesTotal === 0}
            saveDisabled={saveStatus === FilterSaveStatus.DISABLED}
            onQueryChange={onQueryChange}
            onSave={onFilterSave}
            selectedFilterName={selected?.name}
            useConfig={useOrderDataGridQueryBuilderConfig}
          />
        </>
      }
    >
      <DataGridWidget
        domain={domain}
        loading={loading}
        filter={query}
        filterCount={rulesTotal}
        useConfig={useOrderDataGridConfig}
        initialNavigateDetail={({ row }) => ({ to: RouteId.orderDetail(row.id) })}
        loadingProps={{
          query: BASE_ORDER_LIST_QUERY,
          getNodes: (data) => data.orders.nodes,
          getTotalCount: (data) => data.orders.totalCount || 0,
        }}
      />
    </PageLayout>
  );
};
